export default function CandidatesLoading() {
    return (
        <div className="flex">
            {/* Main Content Area */}
            <div className="flex w-full flex-col flex-1 bg-[#fefcfc]">
                {/* Navbar Skeleton */}
                <div className="flex items-center justify-between px-0 py-6 md:py-6 top-0 sticky z-40 bg-white">
                    <div className="flex items-center gap-2">
                        <div className="w-[350px] h-[48px] bg-gray-200 rounded-md animate-pulse" />
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="flex items-center gap-2">
                            <div className="w-[80px] h-[80px] bg-gray-200 rounded-full animate-pulse" />
                        </div>
                        <div className="flex flex-col justify-start items-start gap-2">
                            <div className="w-[150px] h-[38px] bg-gray-200 rounded-md animate-pulse" />
                            <div className="w-[150px] h-[18px] bg-gray-200 rounded-md animate-pulse" />
                        </div>
                    </div>
                </div>

                {/* Content Skeleton */}
                <div className="w-full">
                    <div className="container">
                        <div className="w-full h-[78vh] bg-gray-200 rounded-lg animate-pulse"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}